import { render, staticRenderFns } from "./TarimaContentComponent.vue?vue&type=template&id=66a83e01&"
import script from "./TarimaContentComponent.vue?vue&type=script&lang=js&"
export * from "./TarimaContentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports